/** Seed catalogs for Envío SMS form fields (Orígenes and Listas destinatarios come from API). */

export const SELECT_PLACEHOLDER = 'Seleccionar…';

export const DEFAULT_ENVIO_SMS_ORIGEN = 'IT';

export const ENVIO_SMS_SEVERITIES = [
  'Crítica',
  'Emergencia',
];

export const ENVIO_SMS_STATUSES = [
  'ABIERTA',
  'SOLUCIONADA',
];

/** Estado is not chosen on the form. Final is solucionada; Inicio and Seguimiento are abierta. */
export function estadoFromSecuencia(sequence) {
  const value = String(sequence ?? '').trim();
  if (value === 'Final') return 'SOLUCIONADA';
  if (value === 'Inicio' || value === 'Seguimiento') return 'ABIERTA';
  return '';
}

export const ENVIO_SMS_SEQUENCES = [
  'Inicio',
  'Seguimiento',
  'Final',
];

export const ENVIO_SMS_UNAVAILABLE = 'No disponible';

/**
 * Local wall-clock parts for date/time inputs (YYYY-MM-DD / HH:mm).
 * @param {Date} [now]
 */
export function currentEnvioSmsDateTime(now = new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const mm = String(now.getMinutes()).padStart(2, '0');
  return {
    communication_date: `${y}-${m}-${d}`,
    communication_time: `${hh}:${mm}`,
  };
}

export function emptyEnvioSmsForm(origen = DEFAULT_ENVIO_SMS_ORIGEN, now = new Date()) {
  const {communication_date, communication_time} = currentEnvioSmsDateTime(now);
  return {
    origen,
    lista_id: '',
    short_description: '',
    severity: '',
    message: '',
    incident_manager: '',
    affected_customer: '',
    ticket_id: '',
    oceane: '',
    sequence: '',
    communication_date,
    communication_time,
    declare_end_impact: false,
    end_impact_date: '',
    end_impact_time: '',
    affected_services: '',
    affected_equipment: '',
    prevision: '',
    province: '',
    site: '',
  };
}
